// Noble Power Solutions — shared constants

export const COMPANY = {
  name: "Noble Power Solutions",
  short: "NPS",
  tagline: "Built on Trust. Driven by Results.",
  description:
    "A trusted partner for Engine Sales, Engine Piece Parts, and MRO Solutions across Boeing, Airbus, and McDonnell Douglas fleets.",
  logo: "https://customer-assets.emergentagent.com/job_aog-support-hub/artifacts/zp5jux1w_2fc26cd6-4988-4320-b85e-2f0fcd646b3a.png",
};

export const CONTACT = {
  aogPhone: "+1 (800) 264-6776",
  aogPhoneHref: "tel:+18002646776",
  aogLabel: "AOG 24/7 Hotline",
  salesPhone: "(305) 934-4121",
  salesPhoneHref: "tel:+13059344121",
  aogEmail: "aog@noblepowersolutions.com",
  salesEmail: "tomasNPS@outlook.com",
  mroEmail: "tomasNPS@outlook.com",
  generalEmail: "tomasNPS@outlook.com",
  address: {
    line1: "1850 Aviation Blvd, Suite 400",
    line2: "Miami, FL 33126 — USA",
  },
  hours: "Sales: Mon–Fri 8:00–18:00 EST · AOG Desk: 24 / 7 / 365",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&w=2400&q=80",
  engine:
    "https://images.unsplash.com/photo-1704347824576-acd2e6c0c826?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxqZXQlMjBlbmdpbmUlMjBtYWludGVuYW5jZXxlbnwwfHx8fDE3Nzg2OTM4MTl8MA&ixlib=rb-4.1.0&q=85",
  mro: "https://images.unsplash.com/photo-1737059217479-1f3ee86b5708?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxhaXJjcmFmdCUyMGhhbmdhcnxlbnwwfHx8fDE3Nzg2OTM4MTl8MA&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.unsplash.com/photo-1707919498987-b36fe03f46b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwYWlycGxhbmUlMjBmbHlpbmd8ZW58MHx8fHwxNzc4NjkzODE5fDA&ixlib=rb-4.1.0&q=85",
};

export const TEAM = [
  {
    id: "tomas-angulo",
    name: "Tomas Angulo",
    title: "VP of Sales & Purchasing",
    phone: "(305) 934-4121",
    phoneHref: "tel:+13059344121",
    email: "tomasNPS@outlook.com",
    emailHref: "mailto:tomasNPS@outlook.com",
    photo:
      "https://customer-assets.emergentagent.com/job_aog-support-hub/artifacts/dqymjcea_d19577f6-9f5f-451f-b048-b05d219153c9.png",
  },
  {
    id: "jacob-angulo",
    name: "Jacob Angulo",
    title: "VP of Marketing",
    phone: "(305) 607-5662",
    phoneHref: "tel:+13056075662",
    email: "janguloNPS@outlook.com",
    emailHref: "mailto:janguloNPS@outlook.com",
    photo:
      "https://customer-assets.emergentagent.com/job_aog-support-hub/artifacts/2r0hroph_Screenshot%202026-02-25%20at%2011.54.29%E2%80%AFPM.PNG",
  },
];

export const ENGINES = [
  {
    oem: "CFM International",
    badge: "CFM",
    families: [
      { title: "CFM56 Family", models: ["CFM56-3 Series", "CFM56-5 Series", "CFM56-7B Series"] },
    ],
  },
  {
    oem: "GE Aerospace",
    badge: "GE",
    families: [
      { title: "CF6 Family", models: ["CF6-80 Series"] },
      { title: "CF34 Family", models: ["CF34 Series"] },
    ],
  },
  {
    oem: "Rolls-Royce",
    badge: "RR",
    families: [
      { title: "RB211 Family", models: ["RB211-535 Series"] },
    ],
  },
  {
    oem: "Pratt & Whitney",
    badge: "P&W",
    families: [
      { title: "JT8D Family", models: ["JT8D-200 Series"] },
    ],
  },
];

export const FLEETS = [
  {
    manufacturer: "Boeing",
    badge: "B",
    families: [
      {
        title: "737 Classic & NG",
        models: [
          "737-100",
          "737-200",
          "737-300",
          "737-400",
          "737-500",
          "737-600",
          "737-700",
          "737-800",
          "737-900",
          "737-900ER",
        ],
      },
      {
        title: "737 MAX",
        models: ["737 MAX 7", "737 MAX 8", "737 MAX 9", "737 MAX 10"],
      },
      {
        title: "757",
        models: ["757-200", "757-300"],
      },
    ],
  },
  {
    manufacturer: "Airbus",
    badge: "A",
    families: [
      {
        title: "A300 Family",
        models: [
          "A300B2",
          "A300B4",
          "A300-600",
          "A300-600R",
          "A300F4",
          "A300-600F",
        ],
      },
    ],
  },
  {
    manufacturer: "McDonnell Douglas",
    badge: "MD",
    families: [
      {
        title: "MD-80 Series",
        models: ["MD-81", "MD-82", "MD-83", "MD-87", "MD-88"],
      },
    ],
  },
];

export const SERVICES = [
  {
    id: "engine-parts",
    title: "Engines and Engine Piece Part Sales",
    blurb:
      "Sourcing, qualifying, and trading certified engine piece parts with full traceability and OEM-grade documentation.",
    bullets: [
      "Serviceable, New, and Overhauled rotables & expendables",
      "Full back-to-birth traceability with FAA 8130-3 / EASA Form 1",
      "Consignment, exchange, and outright purchase options",
      "Global brokerage network across CFM56, JT8D, PW4000 & more",
    ],
  },
  {
    id: "mro-sales",
    title: "MRO Sales",
    blurb:
      "End-to-end MRO procurement support — from quoting and routing to logistics — keeping aircraft and engines on schedule.",
    bullets: [
      "Component repair management across approved 145 stations",
      "Engine module and accessory shop visit coordination",
      "Tear-down, harvest, and material recovery programs",
      "AOG-priority routing with worldwide forwarder network",
    ],
  },
];

export const STATS = [
  { value: "24/7", label: "AOG Response" },
  { value: "60+", label: "Aircraft Variants Supported" },
  { value: "ASA-100", label: "Industry Standards" },
  { value: "Global", label: "Distribution Network" },
];
